import moment from 'moment-timezone';

import Base from './Base';
import { formatDate, formatTime } from '../../../../shared_client_utils/bookingUtils';

class DateTime extends Base {
  constructor() {
    super();

    this.id = 4;
    this.name = 'datetime';
    this.searchQuery = 'date_select';
    this.title = 'Date Select';
  }

  getDefaultData(options = {}) {
    return {
      timezone: null,
      date: null,
      beginTime: null,
      endTime: null,
      startDatetime: null,
      endDatetime: null,
      formattedDate: null,
      formattedStartTime: null,
      formattedStopTime: null,
      isHidden: false,
      ...options,
      stepId: this.id,
    };
  }

  getData({ datetime }) {
    return datetime;
  }

  getStepDataFromAppointment({ datetime }, { startTime, endTime }) {
    const startDatetime = moment(startTime);
    const endDatetime = moment(endTime);

    return {
      ...datetime,
      startDatetime,
      endDatetime,
      formattedDate: formatDate(startDatetime),
      formattedStartTime: formatTime(startDatetime),
      formattedStopTime: formatTime(endDatetime),
    };
  }

  prepareResultData({ datetime: { startDatetime, endDatetime } }) {
    const startTime = moment(startDatetime);
    const endTime = moment(endDatetime);

    return {
      startTime: startTime.toISOString(),
      endTime: endTime.toISOString(),
      utcOffset: startTime.utcOffset(),
    };
  }

  resetOptions({ datetime }) {
    const nonResettableOptions = {
      isHidden: datetime.allowToReset ? false : datetime.isHidden,
    };
    return {
      datetime: this.getDefaultData(nonResettableOptions),
    };
  }
}

export default DateTime;
